import { render } from "./LmsLessonView.vue?vue&type=template&id=4a002d6b&scoped=true&ts=true"
import script from "./LmsLessonView.vue?vue&type=script&lang=ts"
export * from "./LmsLessonView.vue?vue&type=script&lang=ts"

import "./LmsLessonView.vue?vue&type=style&index=0&id=4a002d6b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a002d6b"]])

export default __exports__